// extracted by mini-css-extract-plugin
module.exports = {"info__icon":"info_info__icon__uAJum"};